import React from "react";
import DatePicker from "material-ui/DatePicker";
import * as Colors from "../../utils/Color";

const styles = {
  errorStyle: {
    color: Colors.error
  },
  underlineStyle: {
    borderColor: Colors.grey
  },
  underlineFocusStyle: {
    borderColor: Colors.primary
  },
  floatingLabelStyle: {
    fontWeight: "bold",
    color: Colors.grey50
  },
  hintLabelStyle: {
    fontWeight: "bold",
    color: Colors.grey50
  },
  floatingLabelFocusStyle: {
    color: Colors.grey50,
    fontSize: "18px"
  },
  backgroundColor: {
    backgroundColor: Colors.grey
  }
};

class DatePickerUI extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dateTime: null
    };
  }

  setFromDate = (e, dateTime) => {
    this.props.dateFrom && this.props.dateFrom(this.props.hintText, dateTime);

    this.setState({ dateTime });
  };

  render() {
    return (
      <DatePicker
        hintText={this.props.hintText}
        fullWidth={true}
        mode="landscape"
        className="text-field"
        onChange={this.setFromDate}
        hintStyle={styles.hintLabelStyle}
        underlineStyle={styles.underlineStyle}
        underlineFocusStyle={styles.underlineFocusStyle}
        floatingLabelStyle={styles.floatingLabelStyle}
        floatingLabelText={this.props.label}
        floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
      />
    );
  }
}

export default DatePickerUI;



// WEBPACK FOOTER //
// ./src/components/UI/DatePicker.js